import { type YDatabase } from '@databases/collab/y-database';
import { type MetaSdkContract } from '@databases/sdk-types';
import { type Result } from 'neverthrow';

import { setLockedSchema, type SetLockedInput } from '../domain/meta/schemas/locked';
import { type DatabaseMetaSnapshot } from '../domain/meta/types';
import { parse, tryMutate } from '../domain/result';
import { toggleLockStructure } from '../handlers/db/toggle-lock-structure';
import { type SdkError } from '../types';

export type { SetLockedInput } from '../domain/meta/schemas/locked';

/**
 * Manages database-level metadata (structure lock, default view).
 */
export class MetaSdk implements MetaSdkContract {
  constructor(private readonly ydb: YDatabase) {}

  get(): DatabaseMetaSnapshot {
    return {
      isLocked: this.ydb.isLocked ?? false,
      defaultViewId: this.ydb.defaultViewId,
    };
  }

  setLocked(input: SetLockedInput): Result<void, SdkError> {
    return parse(setLockedSchema, input).andThen(({ isLocked }) =>
      tryMutate(() => toggleLockStructure(this.ydb, isLocked))
    );
  }
}
